import {React, useEffect, observer, useLocalStore} from '@api'
import {Checkbox, HTMLTable} from '@blueprintjs/core'
import {Dialog, Button, DialogContent, DialogActions} from '@material-ui/core'
import {LoadingIndicator} from '@modules/common'
import {action, computed} from 'mobx'
import {useContext} from 'react'
import * as css from './UserNotificationSettingsDialog.css'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance, WorkspaceConfig} from '@stores'

class WorkspaceNotificationsStore extends VipLocalStore {
  constructor(stores: StoresInstance) {
    super(stores)
  }

  get catalog() {
    return this.flexLayout.activeOrLastCatalogRoot?.catalog
  }

  get currentUser() { return this.stores.currentUser}

  get config() { return this.stores.config}

  get settings() { return this.currentUser.userSettings}

  @action onCancel = () => {
    this.config.showNotificationsConfig = false
  }

  @action onOK = () => {
    this.config.showNotificationsConfig = false
    this.currentUser.userSettings = this.settings
    this.currentUser.saveUserSettings()
  }

  @action onToggleUserSetting = ({workspaceId, property}: { workspaceId: string, property: 'email' | 'phone' | 'desktop' }) => () => {
    this.settings.workspaces[workspaceId].notifications[property] = !this.currentUser.userSettings.workspaces[workspaceId].notifications[property]
  }

  @computed get loading() {
    const {
      workspaces: {availableWorkspaces},
      currentUser: {userSettings}
    } = this

    return _.isEmpty(availableWorkspaces) || !userSettings?.workspaces
  }
}

export const WorkspaceNotificationsStoreContext = React.createContext<WorkspaceNotificationsStore>(undefined)
export const useWorkspaceNotificationsStore = () => useContext(WorkspaceNotificationsStoreContext)

export const UserNotificationSettingsDialog = observer(function UserNotificationSettingsDialog() {
  const store = useVipLocalStore((ws) => new WorkspaceNotificationsStore(ws)),
    {
      config: {showNotificationsConfig, toggleShowNotificationsConfig},
      workspaces: {availableWorkspaces},
      onCancel, onOK, loading
    } = store

  return (
    <WorkspaceNotificationsStoreContext.Provider value={store}>
      <Dialog
        open={showNotificationsConfig}
        className={css.root}
        classes={{
          container: css.modalContainer
        }}
        onClose={toggleShowNotificationsConfig}
      >
        <DialogContent className={css.content} data-loading={loading}>
          {loading
           ? <LoadingIndicator/>
           : <HTMLTable className={css.workspacesTable}>
             <thead>
             <tr>
               <th>Workspace</th>
               <th>Desktop</th>
               <th>Sync</th>
             </tr>
             </thead>
             <tbody>
             {availableWorkspaces.map((ws, i) => <WorkspaceNotificationsRow key={i} workspace={ws}/>)}
             </tbody>
           </HTMLTable>
          }
        </DialogContent>
        <DialogActions className={css.footer}>
          <Button onClick={onCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={onOK} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </WorkspaceNotificationsStoreContext.Provider>
  )
})

export const WorkspaceNotificationsRow = observer(({workspace}: { workspace: WorkspaceConfig }) => {
  const {title, _id} = workspace,
    {currentUser, onToggleUserSetting, settings: {workspaces}} = useWorkspaceNotificationsStore(),
    {notifications} = workspaces[_id]

  return !currentUser ? null : (
    <tr>
      <td className={css.name}>{title}</td>
      <td className={css.checkbox}><Checkbox checked={notifications?.desktop} onChange={onToggleUserSetting({workspaceId: _id, property: 'desktop'})}/></td>
      <td className={css.checkbox}><Checkbox checked={currentUser.userSettings?.sync?.showSnackbar} onChange={() => currentUser.userSettings.sync.showSnackbar = !currentUser.userSettings.sync.showSnackbar}/></td>
      {/*<td className={css.checkbox}><Checkbox checked={notifications?.phone} onChange={onToggleUserSetting({workspaceId: _id, property: 'phone'})}/></td>*/}
    </tr>)
})


// WEBPACK FOOTER //
// ./src/modules/notifications/UserNotificationSettingsDialog.tsx